import React from 'react';

import { Alert, IconButton, TableCell, TableRow, TextField, Tooltip } from '@mui/material';
import { Draggable} from 'react-beautiful-dnd'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import { UseFieldArrayRemove, useFormContext } from 'react-hook-form';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';


type IngredientEditRowProps = {
  index: number,
  showSort?: boolean,
  remove: UseFieldArrayRemove,
}

export function IngredientEditRow(props: IngredientEditRowProps) {
  const {index} = props;
  const {register, getValues} = useFormContext();

 return (
  <Draggable
    draggableId={`ingredient-${getValues(`ingredients.${index}.id`)}-${index}`}
    index={index}
    key={`ingredient-${getValues(`ingredients.${index}.id`)}-${index}`}>
    {provided => (
      <Tooltip
        placement="top"
        title={<Alert severity="info" icon={<IntegrationInstructionsIcon fontSize="inherit" />}>{getValues(`ingredients.${index}.original_text`)}</Alert>}
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: 'none',
            },
          },
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -14],
                },
              },
            ],
          },
        }}>
        <TableRow
          sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <TableCell align='left' sx={{padding: 0, width: 0}} {...provided.dragHandleProps}>
            <DragIndicatorIcon/>
          </TableCell>
          <TableCell align="left">
            <TextField id={`ingredients.${index}.amount`} variant='outlined' size='small' {...register(`ingredients.${index}.amount`)}/>
          </TableCell>
          <TableCell align="left">
            <TextField id={`ingredients.${index}.unit`} variant='outlined' size='small' {...register(`ingredients.${index}.unit`)}/>
          </TableCell>
          <TableCell align="left">
            <TextField id={`ingredients.${index}.name`} variant='outlined' size='small' {...register(`ingredients.${index}.name`)}/>
          </TableCell>
          { props.showSort &&
          <TableCell align='left'>
            {getValues(`ingredients.${index}.sort`)}
          </TableCell>
          }
          <TableCell align='right' sx={{padding: 0, width: 0}}>
          <IconButton color="primary" aria-label="upload picture" component="span" size='small' onClick={() => {props.remove(index)}}>
            <DeleteIcon fontSize='small'/>
          </IconButton>
          </TableCell>
        </TableRow>
      </Tooltip>
    )}
  </Draggable>
 )
}
